export const EVENTS = {
  CHANGE_STUDY_MODE: 'change-study-mode',
  FILE_UPLOAD: 'file-upload',
  STUDENT_FILES_UPDATE: 'student-files-update',
  PAGE_CHANGE: 'page-change',
  HAND: 'hand',
  TRANSFER_STUDENT_TO_CHECK_TASK: 'transfer-student-to-check-room',
  TRANSFER_STUDENT_TO_EXIT_FROM_ROOM: 'transfer-student-to-exit-from-room',
  CREATE_OR_EDIT_ROOM: 'create-or-edit-room',
  BOARD_PAGE_CHANGE: 'board-page-change'
};
